// Shopify Customer Privacy injects #shopify-pc__banner with an <h2> heading
// that lands before the page <h1> in DOM order, producing a sitewide
// heading-order failure in axe + Lighthouse. The banner wrapper is a
// role="alertdialog" with aria-labelledby referencing the same heading, so
// downgrading the heading to role="presentation" + aria-hidden="true"
// removes the heading-order violation without losing the dialog's
// accessible name (screen readers announce the alertdialog via its
// accessible name, not via the h2 semantic).
(function () {
  'use strict';

  var PATCHED = 'ccBannerHeadingPatched';
  var BANNER_SELECTOR = '#shopify-pc__banner';
  var HEADING_SELECTORS = '#shopify-pc__banner h2, #shopify-pc__banner .shopify-pc__banner__heading';
  var SAFETY_TIMEOUT_MS = 5000;

  function patchHeading(heading) {
    if (!heading || heading.dataset[PATCHED] === '1') return false;
    heading.dataset[PATCHED] = '1';
    heading.setAttribute('role', 'presentation');
    heading.setAttribute('aria-hidden', 'true');
    return true;
  }

  function tryPatchAll() {
    var headings = document.querySelectorAll(HEADING_SELECTORS);
    var patchedAny = false;
    for (var i = 0; i < headings.length; i += 1) {
      if (patchHeading(headings[i])) patchedAny = true;
    }
    return patchedAny;
  }

  function start() {
    if (tryPatchAll()) return;
    if (typeof window.MutationObserver !== 'function') return;

    var disconnected = false;
    var observer = new MutationObserver(function () {
      if (tryPatchAll() && document.querySelector(BANNER_SELECTOR)) {
        observer.disconnect();
        disconnected = true;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (!disconnected) observer.disconnect();
    }, SAFETY_TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
